
    <set-widget
      [entity]="this.entity"
      [layout]="this.layout"
      [options]="options"
      [title]="'Alert Constraints'"
    ></set-widget>
  